<!--
 * @Descripttion: your project
 * @version: 1.0
 * @Author: FeBro
 * @Date: 2021-11-23 16:40:12
 * @LastEditors: LHZ
 * @LastEditTime: 2024-12-12 11:37:43
-->
<template> </template>

<script>
const _host = window.location.host;
// const _host = "jksc.scwjxx.cn";
//域名
const test_host = "hlwyy.gyjkk.cn";
const debug_host = "hlwyy.gyjkk.cn";
const online_host = "hlwyy.gyjkk.cn";

let domainName = "";
let doMain = "";
if (_host == test_host) {
  // 用测试环境接口地址
  domainName = "https://" + test_host + "/api/v1";
  doMain = "https://" + test_host;
}
if (_host == debug_host) {
  domainName = "https://" + debug_host + "/api/v1";
  doMain = "https://" + debug_host;
}
if (_host == online_host) {
  domainName = "https://" + online_host + "/api/v1";
  doMain = "https://" + online_host;
}
if (!domainName) {
  //本地
  domainName = "https://" + test_host + "/api/v1";
  doMain = "https://" + test_host;
}
export default {
  domainName,
  doMain
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/global.vue